import Box from '@mui/material/Box';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { useState } from 'react';
import DropdownTrigger from 'Components/FilterDropdownTrigger';

const STATUS_OPTIONS = [
  { value: '', label: 'Todos' },
  { value: 'pending', label: 'Pendiente' },
  { value: 'approved', label: 'Aprobado' },
  { value: 'rejected', label: 'Rechazado' },
  { value: 'used', label: 'Usado' },
];

interface Props {
  value: string;
  onChange: (status: string) => void;
}

/**
 * Filter bar with a status dropdown for the opportunity requests tab.
 * Uses DropdownTrigger + MUI Menu for visual consistency with SessionsReportFilters.
 */
export default function OpportunityRequestsFilterBar({ value, onChange }: Props) {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const selectedLabel =
    STATUS_OPTIONS.find((opt) => opt.value === value)?.label ?? 'Todos';

  const handleSelect = (optValue: string) => {
    onChange(optValue);
    setAnchorEl(null);
  };

  return (
    <Box display="flex" alignItems="center" gap={2} mb={2}>
      <DropdownTrigger
        icon={null}
        label="Estado"
        value={selectedLabel}
        active={value !== ''}
        onClick={(anchor) => setAnchorEl(anchor)}
      />
      <Menu
        anchorEl={anchorEl}
        open={anchorEl !== null}
        onClose={() => setAnchorEl(null)}
        PaperProps={{ sx: { minWidth: 180 } }}
      >
        {STATUS_OPTIONS.map((opt) => (
          <MenuItem
            key={opt.value}
            selected={opt.value === value}
            onClick={() => handleSelect(opt.value)}
          >
            {opt.label}
          </MenuItem>
        ))}
      </Menu>
    </Box>
  );
}
